import React from "react";

export const AboutUsPage = () => {
    return (
        <div>
            <h1>AboutUs Page</h1>
        </div>
    )
}
